<template>
  <div>
    <div style="height:590px">
      <div class="sct-head"><i class="el-icon-document-copy"></i> 我的合同</div>
      <div class="sct-head-search">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          placeholder="合同编号 / 合同名称 / 签约方名称"
          style="width:500px"
        >
          <el-button
            type="success"
            slot="append"
            icon="el-icon-search"
            style="background-color:rgb(6, 217, 149);color:#fff;"
          ></el-button>
        </el-input>
      </div>
      <div class="sct-body">
        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            max-height="300"
          >
            <el-table-column prop="partA" label="甲方" width="150">
            </el-table-column>
            <el-table-column prop="name" label="甲方电话" width="150">
            </el-table-column>
            <el-table-column prop="partB" label="乙方" width="150">
            </el-table-column>
            <el-table-column prop="name" label="乙方电话" width="150">
            </el-table-column>
            <el-table-column
              prop="content"
              align="center"
              label="合同正文"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  @click="handleClick('look', scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
                <!-- <el-button type="text" size="small">编辑</el-button> -->
              </template>
            </el-table-column>
            <!-- <el-table-column prop="goods" label="合约商品" width="120">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column> -->
            <el-table-column prop="status" label="合约标识" width="120">
            </el-table-column>
            <el-table-column prop="view_base_info" label="基础资料" width="100">
            </el-table-column>

            <el-table-column prop="view_sales" label="销量" width="100">
            </el-table-column>
            <el-table-column prop="view_stock" label="库存" width="100">
            </el-table-column>
            <el-table-column
              prop="alter_base_info"
              label="基础资料"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="start_time" label="开始时间" width="200">
            </el-table-column>
            <el-table-column prop="expire_in" label="结束时间" width="200">
            </el-table-column>
            <el-table-column prop="create_id" label="创建者" width="200">
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="200">
            </el-table-column>
            <el-table-column prop="oper_id" label="修改者" width="200">
            </el-table-column>
            <el-table-column prop="oper_time" label="修改日期" width="200">
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="type"
              label="合同状态"
              width="100"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  @click="handleClick('modify', scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="handleClick('modify', scope.row)"
                  type="text"
                  size="small"
                  style="color:red"
                  >作废</el-button
                >
                <!-- <el-button type="text" size="small">编辑</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
    <el-dialog :visible.sync="DialogVisible" width="90%" top="30px">
      <createCT></createCT>
    </el-dialog>
    <el-dialog title="合同正文" :visible.sync="contractBDVisible" width="55%" top="52px" style="padding:10px;">
      <contractBD></contractBD>
    </el-dialog>
  </div>
</template>
<script>
import createCT from "./createCT.vue";
import contractBD from "./contractBD.vue";
export default {
  name: "viewCT",
  components: { createCT, contractBD },
  data() {
    return {
      //修改、查看合同
      DialogVisible: false,
      //查看合同正文
      contractBDVisible: false,
      options: [
        {
          value: "1",
          label: "全部"
        },
        {
          value: "2",
          label: "已签订"
        },
        {
          value: "3",
          label: "已失效"
        },
        {
          value: "选项4",
          label: "已作废"
        }
      ],
      value: "",
      tableData: [
        {
          start_time: "1990-05-11 16:54:45",
          expire_in: "et cupidatat",
          goods: {
            barcode: "4",
            price: "85"
          },
          fee: {
            fee_no: "mollit elit"
          },
          create_id: "30",
          create_time: "1973-11-20 12:15:27",
          oper_time: "1980-06-16 10:31:12",
          oper_id: "55",
          access_token: "esse consectetur cupidatat",
          alter_base_info: "laboris veniam id qui ipsum",
          other1: "cillum eu",
          view_sales: "ut",
          alter_in_price: "80",
          content: "do quis",
          status: "Ut non tempor elit pariatur",
          partB: "do quis",
          partA: "incididunt cupidatat",
          alter_sale_price: "28",
          view_base_info: "cupidatat nulla et in",
          view_stock: "esse do anim reprehenderit ea"
        }
      ]
    };
  },
  methods: {
    handleClick(key, row) {
      if (key === "modify") {
        this.DialogVisible = true;
      } else if (key === "look") {
        this.contractBDVisible = true;
      }
    }
  }
};
</script>
<style scoped>
.sct-head {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: rgb(250, 250, 249);
  padding: 10px;
  color: #000;
  font-weight: 700;
  border: 1px solid #ebeef5;
}
.el-icon-document-copy {
  font-size: 20px;
  color: rgb(6, 217, 149);
  margin-right: 10px;
}
.sct-head-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border: 1px solid #ebeef5;
  margin-top: -1px;
  padding: 0 20px;
}
.sct-body {
  width: 100%;
  height: 300px;
  max-height: calc(100% - 120px);
  /* background-color: pink; */
  padding: 20px 0;
}

</style>
